module.exports = __webpack_public_path__ + "static/Carole-Lynne-Richardson-214b07c7179b4ae15e23cdb1f1b54c12.jpg";